import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';

/**
 * Enum representing the actions that can be requested from a large language model.
 */
export let ELargeLanguageModelRequestAction;

/**
 * Enum representing the external source of the large language model request.
 */
(function (ELargeLanguageModelRequestAction) {
  ELargeLanguageModelRequestAction["ResolveLumabotIntention"] = "resolve-lumabot-intention";
  ELargeLanguageModelRequestAction["TranslateSingleTemplate"] = "translate-single-template";
  ELargeLanguageModelRequestAction["TranslateTemplates"] = "translate-templates";
  ELargeLanguageModelRequestAction["TranslateSingleText"] = "translate-single-text";
  ELargeLanguageModelRequestAction["Sandbox"] = "sandbox";
  ELargeLanguageModelRequestAction["AssignIntentToText"] = "assign-intent-to-text";
  ELargeLanguageModelRequestAction["DefineAssistant"] = "define-assistant";
  ELargeLanguageModelRequestAction["DefineTool"] = "define-tool";
  ELargeLanguageModelRequestAction["SummarizeMessageTemplate"] = "summarize-message-template";
})(ELargeLanguageModelRequestAction || (ELargeLanguageModelRequestAction = {}));
export let ELargeLanguageModelRequestExternalSource;

/**
 * Enum representing the types of large language model requests.
 */
(function (ELargeLanguageModelRequestExternalSource) {
  ELargeLanguageModelRequestExternalSource["AzureOpenAI"] = "azure-openai";
  ELargeLanguageModelRequestExternalSource["Vapi"] = "vapi";
  ELargeLanguageModelRequestExternalSource["OpenAI"] = "openai";
})(ELargeLanguageModelRequestExternalSource || (ELargeLanguageModelRequestExternalSource = {}));
export let ELargeLanguageModelRequestType;

/**
 * Enum representing the status of a large language model request.
 */
(function (ELargeLanguageModelRequestType) {
  ELargeLanguageModelRequestType["Blocking"] = "blocking";
  ELargeLanguageModelRequestType["Queued"] = "queued";
  ELargeLanguageModelRequestType["StreamIn"] = "stream-in";
  ELargeLanguageModelRequestType["StreamOut"] = "stream-out";
})(ELargeLanguageModelRequestType || (ELargeLanguageModelRequestType = {}));
export let ELargeLanguageModelRequestStatus;

/**
 * Enum representing the location where the results of a large language model request are stored.
 */
(function (ELargeLanguageModelRequestStatus) {
  ELargeLanguageModelRequestStatus["Pending"] = "pending";
  ELargeLanguageModelRequestStatus["Success"] = "success";
  ELargeLanguageModelRequestStatus["Failure"] = "failure";
  ELargeLanguageModelRequestStatus["FailureRateLimit"] = "failure-rate-limit";
})(ELargeLanguageModelRequestStatus || (ELargeLanguageModelRequestStatus = {}));
export let ELargeLanguageModelRequestResultsLocation;

/**
 * Enum representing the feedback types for the results of a large language model request.
 */
(function (ELargeLanguageModelRequestResultsLocation) {
  ELargeLanguageModelRequestResultsLocation["Mongo"] = "mongo";
  ELargeLanguageModelRequestResultsLocation["Redis"] = "redis";
})(ELargeLanguageModelRequestResultsLocation || (ELargeLanguageModelRequestResultsLocation = {}));
export let ELargeLanguageModelRequestResultsFeedbackType;

/**
 * Enum representing the labels for feedback on large language model request results.
 */
(function (ELargeLanguageModelRequestResultsFeedbackType) {
  ELargeLanguageModelRequestResultsFeedbackType["Positive"] = "positive";
  ELargeLanguageModelRequestResultsFeedbackType["Negative"] = "negative";
})(ELargeLanguageModelRequestResultsFeedbackType || (ELargeLanguageModelRequestResultsFeedbackType = {}));
export let ELargeLanguageModelRequestResultsLabel;

/**
 * Interface representing the external status of a large language model request.
 */
(function (ELargeLanguageModelRequestResultsLabel) {
  ELargeLanguageModelRequestResultsLabel["Accuracy"] = "accuracy";
  ELargeLanguageModelRequestResultsLabel["Tone"] = "tone";
  ELargeLanguageModelRequestResultsLabel["Other"] = "other";
})(ELargeLanguageModelRequestResultsLabel || (ELargeLanguageModelRequestResultsLabel = {}));
/**
 * Interface representing the external ID of a large language model request.
 */
/**
 * Interface representing the timers used for large language model request statistics.
 */
/**
 * Interface representing the statistics of a large language model request.
 */
/**
 * Interface representing feedback on the results of a large language model request.
 */
/**
 * Interface representing a large language model request.
 */
export const fieldsLargeLanguageModelRequest = _extends({}, fieldsIBaseModelWithUser, {
  action: {
    type: 'Option',
    values: ELargeLanguageModelRequestAction
  },
  assistantInstance: {
    type: 'ID',
    ref: EModel.AssistantInstance
  },
  context: {
    type: 'Object'
  },
  externalId: {
    type: 'Object'
  },
  externalStatus: {
    type: 'Object'
  },
  parent: {
    type: 'ID',
    ref: EModel.LargeLanguageModelRequest
  },
  prompt: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt
  },
  results: {
    type: 'Object'
  },
  resultsFeedback: {
    type: 'Object'
  },
  resultsLocation: {
    type: 'Option',
    values: ELargeLanguageModelRequestResultsLocation
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: ELargeLanguageModelRequestStatus
  },
  type: {
    type: 'Option',
    values: ELargeLanguageModelRequestType
  }
});